import { ExtranetContainer, useBreakpoint } from '@pharmac-extranet/shared'
import { PharmacH4 } from '@pharmac/ui'
import React from 'react'

export type ExtranetViewHeaderProps = {
  title: string
  children: React.ReactNode[] | React.ReactNode | undefined
}

export const ExtranetViewHeader = ({ title, children }: ExtranetViewHeaderProps) => {
  const { minDesktop } = useBreakpoint()

  return (
    <ExtranetContainer
      full
      flexRow={minDesktop}
      alignCenter={minDesktop}
      flexColumn={!minDesktop}
    >
      <ExtranetContainer
        half
        paddingLargeVertical={minDesktop}
        paddingLargeTop={!minDesktop}
        paddingMediumBottom={!minDesktop}
      >
        <PharmacH4 style={{ color: 'var(--color-primary)' }}>{title}</PharmacH4>
      </ExtranetContainer>
      <ExtranetContainer
        paddingLargeVertical={minDesktop}
        paddingMediumTop={!minDesktop}
        paddingMediumBottom={!minDesktop}
        flexRow
        justifyEnd
        alignCenter
      >
        {children}
      </ExtranetContainer>
    </ExtranetContainer>
  )
}
